import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import "./VarankalFAQ.css";

const VarankalFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const faqData = [
    {
      question: "Is Varankal.com free to use?",
      answer:
        " Yes! Registration is free. You can create your profile and browse matches instantly."
    },
    {
      question: "Are profiles verified?",
      answer:
        "Yes. Each profile goes through manual and digital verification to ensure 100% authenticity."
    },
    {
      question: "Does Varankal serve outside Tamil Nadu?",
      answer:
        "Absolutely! NRIs and Tamils worldwide can find partners here."
    },
    {
      question: "How is privacy maintained?",
      answer:
        "All your information is encrypted and visible only to trusted matches."
    },
     
    {
      question: "Does Varankal Matrimony offer astrology support and bookings?",
      answer:
        "Yes, we provide access to verified astrologers for Kundli matching and personalized consultations. You can schedule sessions directly from your dashboard."
    },
    {
      question: "Why should I choose Varankal?",
      answer:
        "Because we focus on real people, real trust, and real relationships."
    },
  ];

  return (
    <div className="faq-wrapperVM1">
      <h1 className="faq-titleVM1">Frequently Asked Questions</h1>
      <p className="faq-subtitleVM1">
        Everything you need to know before getting started
      </p>

      <div className="faq-gridVM1">
        {faqData.map((faq, index) => (
          <div
            key={index}
            className={`faq-cardVM1 ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggle(index)}
          >
            <div className="faq-questionVM1">
              <strong>{faq.question}</strong>
              <span className="arrowVM1">
                {activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}
              </span>
            </div>
            <div
              className={`faq-answerVM1 ${
                activeIndex === index ? "open" : "closed"
              }`}
            >
              {faq.answer}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VarankalFAQ;
